var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"el-footer footer",staticStyle:{"height":"64px"}},[_c('div',{staticClass:"content"},[_c('span',{on:{"click":_vm.officialWebsite}},[_vm._v("© 五创循环")]),_vm._v(" "),_c('span',{on:{"click":_vm.goGovPage}},[_vm._v("版权所有 / 湘ICP备2022025132号")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-977245d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/AppFooter.vue
// module id = null
// module chunks = 